import { DomainAction } from '../domain/action';
import { DomainError } from '../domain/error';
import { Monitor } from '../ports/monitor';

export class NullMonitor implements Monitor {
    setUser(): void {
        return;
    }
    action<T extends DomainAction>(action: T): void {
        // eslint-disable-next-line no-console
        console.debug('[monitor::action]', action.type, action.context);
    }
    error<T extends DomainError>(error: T): void {
        // eslint-disable-next-line no-console
        console.debug('[monitor::error]', error.name, error.message);
    }
}
